import React, { useMemo } from "react";
import useProjectDetails from "../../hooks/useProjectDetails";

import { getModuleLineNumbersFromProject } from "../../utils/utilities";
import { CoverDataItem } from "../../utils/models";

type Props = any & {
    inspectableItems: CoverDataItem[];
};

function withModules(Component: any): React.FC<Props> {
    return function WithModules(props) {
        const { projectDetails } = useProjectDetails();

        const moduleInspectableItems = useMemo(() => {
            if (projectDetails) {
                return getModuleLineNumbersFromProject(projectDetails).map((option) => ({ label: option, value: option }));
            }

            return [];
        }, [projectDetails]);
    
        return <Component {...props} inspectableItems={moduleInspectableItems} />
    }
}
 
export default withModules;